import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const HomeView: FC = () => (
  <Suspense><LazyHomeView/></Suspense>
);

const LazyHomeView = lazy(importView(
  () => import("../components/HomeView"),
  (it) => it.HomeView,
));
